import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetPartnerAccountPurchasingOrderPolicyMutationVariables = Types.Exact<{
  event_account_id: Types.Scalars['ID'];
  needs_purchasing_order_number: Types.Scalars['Boolean'];
  purchasing_order_email?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type SetPartnerAccountPurchasingOrderPolicyMutation = { __typename?: 'Mutation', setPartnerAccountPurchasingOrderPolicy: { __typename?: 'EventAccount', id: string, needs_purchasing_order_number: boolean, purchasing_order_email?: string | null } };


export const SetPartnerAccountPurchasingOrderPolicyDocument = gql`
    mutation SetPartnerAccountPurchasingOrderPolicy($event_account_id: ID!, $needs_purchasing_order_number: Boolean!, $purchasing_order_email: String) {
  setPartnerAccountPurchasingOrderPolicy(
    event_account_id: $event_account_id
    needs_purchasing_order_number: $needs_purchasing_order_number
    purchasing_order_email: $purchasing_order_email
  ) {
    id
    needs_purchasing_order_number
    purchasing_order_email
  }
}
    `;
export type SetPartnerAccountPurchasingOrderPolicyMutationFn = Apollo.MutationFunction<SetPartnerAccountPurchasingOrderPolicyMutation, SetPartnerAccountPurchasingOrderPolicyMutationVariables>;

/**
 * __useSetPartnerAccountPurchasingOrderPolicyMutation__
 *
 * To run a mutation, you first call `useSetPartnerAccountPurchasingOrderPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPartnerAccountPurchasingOrderPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPartnerAccountPurchasingOrderPolicyMutation, { data, loading, error }] = useSetPartnerAccountPurchasingOrderPolicyMutation({
 *   variables: {
 *      event_account_id: // value for 'event_account_id'
 *      needs_purchasing_order_number: // value for 'needs_purchasing_order_number'
 *      purchasing_order_email: // value for 'purchasing_order_email'
 *   },
 * });
 */
export function useSetPartnerAccountPurchasingOrderPolicyMutation(baseOptions?: Apollo.MutationHookOptions<SetPartnerAccountPurchasingOrderPolicyMutation, SetPartnerAccountPurchasingOrderPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPartnerAccountPurchasingOrderPolicyMutation, SetPartnerAccountPurchasingOrderPolicyMutationVariables>(SetPartnerAccountPurchasingOrderPolicyDocument, options);
      }
export type SetPartnerAccountPurchasingOrderPolicyMutationHookResult = ReturnType<typeof useSetPartnerAccountPurchasingOrderPolicyMutation>;
export type SetPartnerAccountPurchasingOrderPolicyMutationResult = Apollo.MutationResult<SetPartnerAccountPurchasingOrderPolicyMutation>;
export type SetPartnerAccountPurchasingOrderPolicyMutationOptions = Apollo.BaseMutationOptions<SetPartnerAccountPurchasingOrderPolicyMutation, SetPartnerAccountPurchasingOrderPolicyMutationVariables>;